// This matches LockType in the protobuf definition.
// The C++ LockType starts from 0 and transforms to the protobuf type.
export var LockType;
(function (LockType) {
    LockType[LockType["NIL_LOCK"] = 1] = "NIL_LOCK";
    LockType[LockType["CONCURRENT_READ"] = 2] = "CONCURRENT_READ";
    LockType[LockType["CONCURRENT_WRITE"] = 3] = "CONCURRENT_WRITE";
    LockType[LockType["PROTECTED_READ"] = 4] = "PROTECTED_READ";
    LockType[LockType["PROTECTED_WRITE"] = 5] = "PROTECTED_WRITE";
    LockType[LockType["EXCLUSIVE"] = 6] = "EXCLUSIVE";
    LockType[LockType["COUNT"] = 7] = "COUNT";
})(LockType || (LockType = {}));
